import { injectable } from 'inversify';

import axios, { AxiosPromise } from 'axios';

import IocContainer from '../container/IocContainer';
import SERVICES     from '../services/services';

import Certificate from '../interfaces/Certificate';
import Auth from '../interfaces/Auth';

@injectable()
export default class CertificateProvider implements Certificate {

  http;
  status;
  
  path = '/certificate/';
  auth = IocContainer.get<Auth>(SERVICES.AUTH);

  constructor () {
    this.http = axios.create({
      baseURL: process.env.API_URL,
      headers: {
        Accept: 'application/json',
      },
    });
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async requestCertificate(email) {
    return await this.http.post('/getcertificate-request/', {
        email,
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.auth.token(),
        },
      });
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async statusCertificate(email) {
    return this.http.post('certificate-status', {
        email,
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + this.auth.token(),
        },
      });
  }
  
  public async updateUser(formData) {
    return await this.http.post('/user/', formData, {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + this.auth.token(),
        },
      });
  }
}
